// extracted by mini-css-extract-plugin
export var callCard = "_m8-0";
export var callMessageButton = "_m8-1";
export var helpIcon = "_m8-3";
export var helpIconContainer = "_m8-4";
export var verticalDivider = "_m8-2";